var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header d-flex align-end mb-6"},[_c('div',{staticClass:"rest-info ps-2"},[_c('div',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm.$t('edit_campaign'))+" ")]),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.campaignName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }